import { render, staticRenderFns } from "./CustomFormRecordList.vue?vue&type=template&id=f8eb97b4"
import script from "./CustomFormRecordList.js?vue&type=script&lang=js&external"
export * from "./CustomFormRecordList.js?vue&type=script&lang=js&external"
import style0 from "./CustomFormRecordList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports